import { StatusEnum } from "./status";

export enum TaskType {
  PIC = "PIC",
  NEW_HIRE_VIDEO = "NEW_HIRE_VIDEO",
  ZAPPOS_SHOE_PROMOTION = "ZAPPOS_SHOE_PROMOTION",
}
export interface TaskStatusModel {
  taskType: TaskType;
  taskStatus: StatusEnum;
  candidateId: string;
  taskId: string;
  expirationDate?: string;
}

export interface ZapposStatusModel extends Omit<TaskStatusModel, "taskStatus"> {
  taskStatus: ZapposStatusEnum;
}

export enum ZapposStatusEnum {
  ELIGIBLE = "ELIGIBLE",
  INELIGIBLE = "INELIGIBLE",
}
